import Button from 'components/Button/Button'
import React from 'react'
import { Row, Col } from 'react-grid-system'
import { CourtImageProps } from './CourtImage.props'
import {
  CourtDefault,
  CourtImageContainer,
  CourtPhoto,
} from './CourtImage.styled'

const CourtImage: React.FC<CourtImageProps> = ({ uri }) => {
  return (
    <CourtImageContainer>
      <Row>{!uri ? <CourtDefault /> : <CourtPhoto src={uri} />}</Row>
      <Row style={{ marginTop: 16 }}>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Button
            text="Replace image"
            variant="primary"
            preset="filled"
            size={'medium'}
          />
        </Col>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Button
            text="Update waiver"
            variant="primary"
            preset="filled"
            size={'medium'}
          />
        </Col>
      </Row>
    </CourtImageContainer>
  )
}

export default CourtImage
